export default __webpack_public_path__ + "static/media/051-is greater than or equal to.5c3afd82.svg";